module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fCRc4EsA.d69a2de8.woff2";